import type { BoardCard } from './contracts'

export type DueTone = 'overdue' | 'soon' | 'later' | 'none'

function dateOnlyInTimeZone(now: Date, timeZone: string): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now)
}

export function dueTone(dueOn: string | null | undefined, now = new Date(), timeZone = 'America/Chicago'): DueTone {
  if (!dueOn) return 'none'
  const today = dateOnlyInTimeZone(now, timeZone)
  if (dueOn < today) return 'overdue'
  const tomorrowDate = new Date(`${today}T12:00:00Z`)
  tomorrowDate.setUTCDate(tomorrowDate.getUTCDate() + 1)
  const tomorrow = tomorrowDate.toISOString().slice(0, 10)
  return dueOn <= tomorrow ? 'soon' : 'later'
}

export function sortBoardCards(cards: BoardCard[]): BoardCard[] {
  return [...cards].sort((left, right) => {
    const leftDue = left.earliestTask?.dueOn ?? null
    const rightDue = right.earliestTask?.dueOn ?? null
    if (leftDue && rightDue && leftDue !== rightDue) return leftDue.localeCompare(rightDue)
    if (leftDue && !rightDue) return -1
    if (!leftDue && rightDue) return 1
    if (left.position !== right.position) return left.position - right.position
    return left.createdAt.localeCompare(right.createdAt)
  })
}
